var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { CreativeRepository } from '@/models/Creative';
import { Creative } from '@/models/CampaignOperation/CompoundCampaign/Creative';
import { locationGroupType } from '@/components/Advertiser/Operation/PointGroup/PointGroupOperation/constants';
var DeliveryLocationGroupFormModel = /** @class */ (function () {
    function DeliveryLocationGroupFormModel(item) {
        if (item === void 0) { item = {}; }
        var _a = item, id = _a.id, name = _a.name, locationGroupId = _a.locationGroupId, accessibleType = _a.accessibleType, locationType = _a.locationType, _b = _a.radius, radius = _b === void 0 ? locationType === locationGroupType.CUSTOM_LOCATION ? 1000 : 300 : _b, _c = _a.creatives, creatives = _c === void 0 ? [] : _c, _d = _a.deleted, deleted = _d === void 0 ? false : _d, _e = _a.isSimulation, isSimulation = _e === void 0 ? false : _e, _f = _a.isUsable, isUsable = _f === void 0 ? true : _f, _g = _a.administrativeDistrictType, administrativeDistrictType = _g === void 0 ? null : _g, _h = _a.area, area = _h === void 0 ? null : _h, _j = _a.categoryId, categoryId = _j === void 0 ? null : _j, _k = _a.conditions, conditions = _k === void 0 ? null : _k;
        this.id = id;
        this.name = name;
        this.locationGroupId = locationGroupId;
        this.accessibleType = accessibleType;
        this.locationType = locationType;
        this.radius = radius;
        this.creatives = creatives.map(Creative.assign);
        this.deleted = deleted;
        this.creativesFetched = false;
        this.isSimulation = isSimulation;
        this.isUsable = isUsable;
        this.administrativeDistrictType = administrativeDistrictType;
        this.area = area;
        this.categoryId = categoryId;
        this.conditions = conditions;
    }
    DeliveryLocationGroupFormModel.assign = function (data) {
        return new DeliveryLocationGroupFormModel(data);
    };
    Object.defineProperty(DeliveryLocationGroupFormModel.prototype, "hasWarning", {
        /**
         * 紐付いたクリエイティブが下記の条件に当てはまるかどうか
         * - そもそもクリエイティブが紐付いていない
         * - inactive なクリエイティブがある
         * - 期限切れのクリエイティブがある
         * - reject されたクリエイティブがある
         * @return {boolean}
         */
        get: function () {
            if (!this.creativesFetched)
                return false;
            return (this.noCreativesWarning ||
                this.hasInactiveCreativesWarning ||
                this.hasExpiredCreativesWarning ||
                this.hasRejectedCreativesWarning);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DeliveryLocationGroupFormModel.prototype, "noCreativesWarning", {
        get: function () {
            return this.creatives.length === 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DeliveryLocationGroupFormModel.prototype, "hasInactiveCreativesWarning", {
        get: function () {
            return this.creatives.some(function (c) { return !c.isActive; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DeliveryLocationGroupFormModel.prototype, "hasExpiredCreativesWarning", {
        get: function () {
            return this.creatives.some(function (c) { return c.isExpired; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DeliveryLocationGroupFormModel.prototype, "hasRejectedCreativesWarning", {
        get: function () {
            return this.creatives.some(function (c) { return c.isRejected; });
        },
        enumerable: false,
        configurable: true
    });
    DeliveryLocationGroupFormModel.prototype.fetchCreatives = function () {
        return __awaiter(this, void 0, void 0, function () {
            var currentFetchedStatus, _a, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        currentFetchedStatus = this.creativesFetched;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        this.creativesFetched = false;
                        _a = this;
                        return [4 /*yield*/, CreativeRepository.findByIdsWithFolderInfo(this.creatives.flat())];
                    case 2:
                        _a.creatives = _b.sent();
                        this.creativesFetched = true;
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _b.sent();
                        console.error(e_1);
                        this.creativesFetched = currentFetchedStatus;
                        throw new Error('配信地点グループに紐付いたクリエイティブが取得できません');
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return DeliveryLocationGroupFormModel;
}());
export { DeliveryLocationGroupFormModel };
